import { render } from "./AdditionalStats.vue?vue&type=template&id=4fd5d768&scoped=true"
import script from "./AdditionalStats.vue?vue&type=script&lang=js"
export * from "./AdditionalStats.vue?vue&type=script&lang=js"

import "./AdditionalStats.vue?vue&type=style&index=0&id=4fd5d768&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd5d768"]])

export default __exports__